"use strict";Object.defineProperty(exports, "__esModule", {value: true});

// Mirrors the server's keyword rules (UpdateTeam). The server is the source
// of truth and sends the same messages.

 const MAX_KEYWORDS = 20; exports.MAX_KEYWORDS = MAX_KEYWORDS
 const MAX_PHRASE_LENGTH = 40; exports.MAX_PHRASE_LENGTH = MAX_PHRASE_LENGTH
 const MAX_REPLY_LENGTH = 320; exports.MAX_REPLY_LENGTH = MAX_REPLY_LENGTH

const KEYWORD_FORMAT = /^[A-Z0-9]{1,20}$/

const CANT = 'can\u2019t be a keyword.'

/* The words no keyword can be, in the groups the Keywords tab lists. Each
 * group's first word is the one carriers name; the server reserves the
 * same words. */
 const RESERVED_KEYWORDS = {
  optOut: ['STOP', 'STOPALL', 'UNSUBSCRIBE', 'CANCEL', 'END', 'QUIT', 'REVOKE', 'OPTOUT'],
  optIn: ['START', 'YES', 'UNSTOP'],
  help: ['HELP', 'INFO'],
  spanishOptOut: ['PARAR', 'DETENER', 'CANCELAR', 'BAJA', 'ALTO'],
} ; exports.RESERVED_KEYWORDS = RESERVED_KEYWORDS

const isIn = (words, word) => words.includes(word)

const reservedMessage = (word) => {
  if (isIn(exports.RESERVED_KEYWORDS.optOut, word)) return `Carriers use ${word} to opt people out, so it ${CANT}`
  if (isIn(exports.RESERVED_KEYWORDS.optIn, word)) return `Carriers use ${word} to turn texts back on, so it ${CANT}`
  if (word === 'HELP') return `BloomText answers HELP with your organization\u2019s help reply, so it ${CANT}`
  if (word === 'INFO') return `Carriers treat INFO like HELP, so it ${CANT} Try DIRECTIONS or CLINIC.`
  if (isIn(exports.RESERVED_KEYWORDS.spanishOptOut, word)) return `Patients use ${word} to opt out, so it ${CANT}`
  return undefined
}

 const normalizeKeyword = (keyword) => keyword.trim().toUpperCase(); exports.normalizeKeyword = normalizeKeyword



/* Checks one keyword against the team's other keywords (the list without
   the one being edited). Returns an empty object when it can be saved. */
 const validateKeyword = (draft, others) => {
  const errors = {}
  const keyword = exports.normalizeKeyword.call(void 0, draft.Keyword)

  if (others.length >= exports.MAX_KEYWORDS) {
    errors.Keyword = `This team has ${exports.MAX_KEYWORDS} keywords, the most it can have.`
  } else if (!KEYWORD_FORMAT.test(keyword)) {
    errors.Keyword = 'Use one word of up to 20 letters or numbers.'
  } else if (reservedMessage(keyword)) {
    errors.Keyword = reservedMessage(keyword)
  } else if (others.some(k => exports.normalizeKeyword.call(void 0, k.Keyword) === keyword)) {
    errors.Keyword = `${keyword} is already a keyword on this team.`
  }

  const phrase = draft.Phrase.trim()
  if (!phrase) {
    errors.Phrase = 'Add what the keyword is for, like \u201Cto request a refill\u201D.'
  } else if (phrase.length > exports.MAX_PHRASE_LENGTH) {
    errors.Phrase = `Keep the For phrase to ${exports.MAX_PHRASE_LENGTH} characters or fewer.`
  }

  const reply = draft.Reply.trim()
  if (!reply) {
    errors.Reply = 'Add the reply patients get.'
  } else if (reply.length > exports.MAX_REPLY_LENGTH) {
    errors.Reply = `Replies can be at most ${exports.MAX_REPLY_LENGTH} characters.`
  }

  return errors
}; exports.validateKeyword = validateKeyword
